import React, { useEffect, useState } from 'react'
import LabelNumber from '../styled-components/LabelNumber';
import Goal from "../assets/event_icons/Goal.png";
import YellowCardSvg from "../assets/event_icons/Yellow_card.png";
import RedCardSvg from "../assets/event_icons/red_card.png";
import { IMatchEventCardData, ITeamEventsList } from '../types/IMatchEventCardData';

interface CombinedEvent {
    homeTeam: ITeamEventsList | null;
    awayTeam: ITeamEventsList | null;
}

const eventIcons: { [key: string]: string } = {
    goal: Goal,
    "yellow_card": YellowCardSvg,
    "red_card": RedCardSvg,
    "own_goal": Goal
};

interface MatchListProps {
    matchData?: IMatchEventCardData | null;
    matchId: number;
}

const formatDateTime = (dateStr: string): string => {
    const date = new Date(dateStr);
    // Get the day of the week
    const dayOfWeek = new Intl.DateTimeFormat('en-US', { weekday: 'short' }).format(date);
    // Get the date formatted as MM.DD.YYYY
    const formattedDate = new Intl.DateTimeFormat('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
    }).format(date).replace(/\//g, '.');
    // Get the time formatted as HH:MM
    const time = date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    });
    // Combine everything
    return `${dayOfWeek} ${formattedDate} - ${time}`;
};

const convertSecondsToMinutes = (seconds: number): string => {
    const minutes = seconds / 60;
    return minutes.toFixed(2); // Fixes the number of digits after the decimal to 2
};

const MatchEventInfo: React.FC<MatchListProps> = ({ matchData, matchId }) => {
    const [matchDate, setMatchDate] = useState<string>("");
    const maxLength = Math.max(matchData?.homeTeamEventsList.length!, matchData?.awayTeamEventsList.length!);
    const combinedData: CombinedEvent[] = Array.from({ length: maxLength }, (_, index) => ({
        homeTeam: matchData?.homeTeamEventsList[index] || null, // Use null if no data exists
        awayTeam: matchData?.awayTeamEventsList[index] || null // Use null if no data exists
    }));

    useEffect(() => {
        const formattedMatchDate = formatDateTime(matchData?.matchDate!);
        setMatchDate(formattedMatchDate);
    }, [matchData])

    return (
        <div className='page-match-detail-wrapper'>
            <div className='page-match-event-info'>
                <div className='match-name'>
                    <LabelNumber className='attack-defense-data'>{matchDate}</LabelNumber>
                </div>
            </div>
            <div className='match-event-details'>
                {combinedData.map((item, index) => (
                    <div key={index} className="event-row">
                        <div className="event-column left">
                            {item.homeTeam && (
                                <>
                                    <img className='event-icon' src={eventIcons[item.homeTeam.eventType]} alt={item.homeTeam.eventType} />
                                    <div className='match-event-information'>
                                        <LabelNumber className='event-player-card-details'>{item.homeTeam.playerName} - {convertSecondsToMinutes(item.homeTeam.eventMinute)}</LabelNumber>
                                        {item.homeTeam.eventType === 'goal' && item.homeTeam.assistPlayerName !== "" &&
                                            <LabelNumber className='goal-assist-name'>(Asst - {item.homeTeam.assistPlayerName})</LabelNumber>}
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="event-column right">
                            {item.awayTeam && (
                                <>
                                    <div className='match-event-information away-team'>
                                        <LabelNumber className='event-player-card-details'>{item.awayTeam.playerName} - {convertSecondsToMinutes(item.awayTeam.eventMinute)}</LabelNumber>
                                        {item.awayTeam.eventType === 'goal' && item.awayTeam.assistPlayerName !== "" &&
                                            <LabelNumber className='goal-assist-name'>(Asst - {item.awayTeam.assistPlayerName})</LabelNumber>}
                                    </div>
                                    <img className='event-icon' src={eventIcons[item.awayTeam.eventType]} alt={item.awayTeam.eventType} />
                                </>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default MatchEventInfo
